export const SET_CURRENT_RUN = 'SET_CURRENT_RUN';
export const SET_CURRENT_TENANT = 'SET_CURRENT_TENANT';
export const SET_SUMMARY_REPORT = 'SET_SUMMARY_REPORT';
export const CLEAR_SUMMARY_REPORT = 'CLEAR_SUMMARY_REPORT';
